'use client';

// Choix du thème — auto, clair, sombre.
//
// Un POPOVER et non plus un bouton qui fait défiler les trois valeurs : l'ancien cyclait à
// l'aveugle, si bien qu'atteindre « sombre » depuis « auto » demandait deux clics sans jamais
// montrer les options. Ici les trois sont visibles et l'état courant est coché.
//
// Réutilise `Menu` : même mécanique de fermeture, mêmes rayons, même comportement clavier
// que tous les autres panneaux de l'application.

import { Moon, Sun, SunMoon } from 'lucide-react';

import { Menu, MenuItem } from '@/components/ui/Menu';
import { useT } from '@/hooks/useT';
import { useTheme, type ThemeMode } from '@/lib/theme/ThemeProvider';

const MODES: Array<{ mode: ThemeMode; Icon: typeof Sun }> = [
  { mode: 'auto', Icon: SunMoon },
  { mode: 'light', Icon: Sun },
  { mode: 'dark', Icon: Moon },
];

export function ThemeMenu({ triggerClassName }: { triggerClassName: string }) {
  const { t } = useT('common');
  const { mode, setMode } = useTheme();

  const Current = MODES.find((m) => m.mode === mode)?.Icon ?? SunMoon;

  return (
    <Menu
      label={t('theme.label')}
      width="w-48"
      triggerClassName={triggerClassName}
      trigger={<Current className="size-[18px]" />}
    >
      {MODES.map(({ mode: value, Icon }) => (
        <MenuItem
          key={value}
          icon={Icon}
          label={t(`theme.${value}`)}
          selected={value === mode}
          onSelect={() => setMode(value)}
        />
      ))}
    </Menu>
  );
}
